import // setStorage,
// getStorage getStorage('menuUsedStorage', 0) ||
// removeStorage,
// clearStorage
'@/utils'

const { selectedKeys, routerPath } = {
  selectedKeys: ['平台门户'],
  routerPath: ''
} // 用户的菜单使用缓存
const state = {
  menuList: [
    { title: '平台门户', routerPath: '' },
    {
      title: '开放许可',
      routerPath: ''
    },
    { title: '成果展示', routerPath: '' },
    { title: '技术需求库', routerPath: '' },
    // { title: '智能撮合', routerPath: '' },
    // { title: '人才团队', routerPath: '' },
    { title: '服务机构', routerPath: '' },
    { title: '产业信息服务', routerPath: '' },
    {
      title: '新闻资讯',
      routerPath: ''
    }
  ],
  selectedKeys,
  curMenuRouterPath: routerPath
}
const getters = {
  stateMenuList: state => {
    let key = process.env.VUE_APP_KEY
    // 梅州
    if (key === 'Mz') {
      state.menuList.splice(3, 0, { title: '专利专题库', routerPath: '' })
      state.menuList.splice(4, 0, { title: '人才团队', routerPath: '' })
    }
    // 深圳市新材料产业知识产权运营公共服务平台
    if(key === 'SzTech') {
      state.menuList.splice(6, 0, { title: '专利检索', routerPath: 'patyee'})
    }
    return state.menuList
  },
  stateSelectedKeys: state => state.selectedKeys, // 当前选中的item
  stateRouterPath: state => state.curMenuRouterPath // 当前路由
}
const mutations = {
  updateMenuItemStatus: (state, params) => {
    const { selectedKeys, routerPath } = params
    state.selectedKeys = selectedKeys
    state.routerPath = routerPath
    // setStorage('menuUsedStorage', params, 0)
  }
}
const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
